import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'
import { PagesComponent } from './pages.component'
import { RouterPath } from '../config/global-const'

const routes: Routes = [
    {
        path: '',
        component: PagesComponent,
        children: [
            {
                path: '',
                redirectTo: RouterPath.WORKING.PATH,
            },
            {
                path: RouterPath.WORKING.PATH,
                loadChildren: () => import('./working/working.module').then((m) => m.WorkingModule),
            },
            {
                path: RouterPath.EMPLOYEES.PATH,
                loadChildren: () => import('./employee/employee.module').then((m) => m.EmployeeModule),
            },
            {
                path: RouterPath.GIFT_CARD.PATH,
                loadChildren: () => import('./gift-card/gift-card.module').then((m) => m.GiftCardModule),
            },
            {
                path: RouterPath.REPORT.PATH,
                loadChildren: () => import('./report/report.module').then((m) => m.ReportModule),
            },
            {
                path: RouterPath.SALON_SERVICE.PATH,
                loadChildren: () => import('./salon-service/salon-service.module').then((m) => m.SalonServiceModule),
            },
            {
                path: RouterPath.CHECK_IN.PATH,
                loadChildren: () => import('./check-in/check-in.module').then((m) => m.CheckInModule),
            },
            {
                path: RouterPath.PROFILE.PATH,
                loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
            },
            {
                path: RouterPath.SETTING.PATH,
                loadChildren: () => import('./setting/setting.module').then((m) => m.SettingModule),
            },
            {
                path: RouterPath.ERRORS.PATH,
                loadChildren: () => import('./error-page/error-page.module').then((m) => m.ErrorPageModule),
            },
            {
                path: RouterPath.ADMIN.PATH,
                loadChildren: () => import('./admin/admin-routing.module').then((m) => m.AdminRoutingModule),
            },
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PagesRoutingModule {}
